/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

class CustomTooltip extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    var trigger = this.querySelector('.custom-tooltip-trigger');
    var tooltip = this.querySelector('.custom-tooltip-body');
    var close = this.querySelector('.custom-tooltip-body-close');

    if (trigger != null) {
      trigger.addEventListener("click", function(event) { 
        if (tooltip != null) {
          tooltip.classList.toggle('show');
        }
      });
    }

    if (close != null) {
      close.addEventListener("click", function(event) { 
        if (tooltip != null) {
          tooltip.classList.remove('show');
        }
      });
    }

    document.addEventListener("click", function(e) { 
      if (!e.target.closest('.custom-tooltip-body') && e.target != trigger) {
        if (tooltip != null) {
          tooltip.classList.remove('show');
        }
      }
    });
  }
}
customElements.define('custom-tooltip', CustomTooltip);

class ProductTabs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    var navButtons = this.querySelectorAll('.custom-product-tabs-nav-item');
    var bodyItems = this.querySelectorAll('.custom-product-tabs-body-item');

    if (navButtons.length) {
      navButtons.forEach(function(item) {
        item.addEventListener("click", function(e) {
          var itemId = this.getAttribute('data-id');
          navButtons.forEach(function(el) {
            el.classList.remove('active');
          });
          this.classList.add('active');

          if (bodyItems.length) {
            bodyItems.forEach(function(el) {
              if (itemId == el.getAttribute('data-id')) {
                el.classList.add('active');
              } else {
                el.classList.remove('active');
              }
            });
          }
        });
      });
    }
  }
}
customElements.define('product-tabs', ProductTabs);
document.addEventListener("DOMContentLoaded", (event) => {
var containers = document.querySelectorAll(".collection__cards");
containers.forEach((container) => {			
    container.matchHeight({elements: '.o-layout__item'});
});

// var productContainers = document.querySelectorAll("items-scroll .grid-layout");
// productContainers.forEach((container) => {			
//     container.matchHeight({elements: '.product-card'});
// });
  
});